module.exports = __webpack_public_path__ + "img/pt-BR.8223d1c3.svg";